import { useMelwaysLink } from '@seek/melways-react';
import { useTranslations } from '@vocab/react';
import { Text, TextLink } from 'braid-design-system';

import translations from './Review.vocab';

export const PrivacyPolicy = () => {
  const { t } = useTranslations(translations);
  const collectionNoticeUrl = useMelwaysLink('/collection-notice');
  const privacyUrl = useMelwaysLink('/privacy');

  return (
    <Text size="small">
      {t('All personal information', {
        CollectionNotice: () => (
          <TextLink href={collectionNoticeUrl} weight="weak" target="_blank">
            {t('Collection Notice')}
          </TextLink>
        ),
        PrivacyPolicy: () => (
          <TextLink href={privacyUrl} weight="weak" target="_blank">
            {t('Privacy Policy')}
          </TextLink>
        ),
      })}
    </Text>
  );
};
